import { z } from 'zod';

export type AuctionBidCreateForm = {
    bid_value: number,
    auction_rules_accepted: 0 | 1,
};

export type AuctionBidCreateFormErrors = {
    bid_value?: string[],
    auction_rules_accepted?: string[],
};

export const AuctionBidCreateFormErrors = z.object({
    bid_value: z.string().array().optional(),
    auction_rules_accepted: z.string().array().optional(),
});

